export default {
  maps: {
    map1: [
      [0,1,2,2,2,1,0],
      [0,1,2,2,2,1,0],
      [0,1,2,2,2,1,0],
      [0,3,0,'e',0,3,0],
      [0,1,0,0,0,1,0],
      [0,3,0,0,0,3,0],
      [0,1,0,0,0,1,0],
      [0,3,0,0,0,3,0],
      [0,1,0,0,0,1,0],
      [0,3,0,'s',0,3,0]
    ],

    map2: [
      [0,2,2,2,0,1,0],
      [0,2,2,2,0,0,0],
      [0,2,2,2,0,1,0],
      [0,3,'e',3,0,0,0],
      [0,1,0,1,0,1,0],
      [0,3,0,3,0,3,0],
      [0,1,0,1,4,1,0],
      [0,3,0,0,0,3,0],
      [0,1,0,0,0,1,0],
      [0,0,3,0,'s',3,0]
    ],

    map3: [
      [0,1,0,2,2,2,0],
      [0,0,0,2,2,2,0],
      [0,1,4,2,2,2,0],
      [0,0,0,0,'e',0,0],
      [0,1,4,1,0,1,0],
      [0,3,0,3,0,0,0],
      [0,1,0,1,0,1,0],
      [0,3,0,0,0,0,0],
      [0,1,0,1,0,1,0],
      [0,0,'s',0,3,0,0]
    ],

    map4: [
      [0,2,2,2,0,1,0],
      [0,2,2,2,0,0,0],
      [0,2,2,2,4,1,0],
      [0,3,'e',0,0,3,0],
      [0,1,4,1,0,1,0],
      [0,0,0,3,0,3,0],
      [0,1,0,1,0,1,0],
      [0,0,0,3,0,3,0],
      [0,1,4,1,0,1,0],
      [0,3,'s',0,0,3,0]
    ],

    map5: [
      [0,1,2,2,2,1,0],
      [0,0,2,2,2,0,0],
      [0,1,2,2,2,1,0],
      [0,3,0,'e',0,0,0],
      [0,1,0,1,4,1,0],
      [0,0,0,0,0,0,0],
      [0,1,0,1,0,1,0],
      [0,0,0,3,0,0,0],
      [0,1,4,1,0,1,0],
      [0,0,3,0,'s',0,0]
    ],

    map6: [
      [0,2,2,2,0,1,0],
      [0,2,2,2,0,0,0],
      [0,2,2,2,4,1,0],
      [0,3,'e',0,0,3,0],
      [0,1,4,1,0,1,0],
      [0,0,0,3,0,3,0],
      [0,1,4,1,0,1,0],
      [0,3,0,0,0,3,0],
      [0,1,0,1,4,1,0],
      [0,3,'s',0,0,3,0]
    ],

    map7: [
      [0,1,0,2,2,2,1],
      [0,0,0,2,2,2,1],
      [0,1,0,2,2,2,1],
      [0,3,0,3,'e',0,3],
      [0,1,0,1,0,1,0],
      [0,3,0,0,0,0,3],
      [0,1,4,1,4,0,1],
      [0,3,0,0,0,0,3],
      [1,4,0,1,4,1,0],
      [3,0,0,0,0,'s',0]
    ],

    map8: [
      [0,2,2,2,0,1,0],
      [0,2,2,2,0,0,0],
      [0,2,2,2,4,1,0],
      [3,0,'e',0,0,0,1],
      [0,1,4,1,4,0,3],
      [3,0,0,0,0,0,3],
      [0,1,0,1,4,1,0],
      [0,3,0,3,0,0,0],
      [0,1,0,1,0,1,0],
      [0,3,'s',3,0,0,0]
    ],

    map9: [
      [1,0,2,2,2,0,1],
      [0,0,2,2,2,0,0],
      [1,4,2,2,2,4,1],
      [0,0,3,'e',0,0,3],
      [1,0,1,0,1,4,1],
      [0,0,3,0,0,0,3],
      [1,4,1,4,1,0,1],
      [3,0,0,0,3,0,3],
      [1,0,1,0,1,0,1],
      [3,'s',3,0,0,0,3]
    ],

    map10: [
      [0,1,0,2,2,2,1],
      [0,0,0,2,2,2,1],
      [0,1,4,2,2,2,1],
      [0,3,0,0,'e',0,3],
      [0,1,0,1,4,1,0],
      [0,3,0,0,0,0,3],
      [0,1,4,1,4,0,1],
      [0,3,0,0,0,0,3],
      [0,1,0,1,4,1,0],
      [0,3,0,0,0,'s',0]
    ],

    map11: [
      [0,2,2,2,0,1,0],
      [0,2,2,2,0,0,0],
      [0,2,2,2,4,1,4],
      [0,0,'e',0,0,0,0],
      [1,1,4,1,4,0,0],
      [3,0,0,0,0,0,0],
      [3,0,4,1,4,1,0],
      [3,0,0,0,0,3,0],
      [1,1,4,1,0,1,0],
      [0,0,0,3,0,'s',3]
    ],

    map12: [
      [1,0,0,0,2,2,2],
      [0,4,4,1,2,2,2],
      [1,0,0,0,2,2,2],
      [0,0,3,0,0,'e',0],
      [1,0,1,0,0,3,1],
      [0,0,0,4,4,4,0],
      [1,0,1,0,0,0,1],
      [0,0,0,0,3,0,0],
      [1,4,1,4,1,0,1],
      [0,'s',0,0,0,0,3]
    ]
  },

  obstacles: [
    { obstacleId: 'obstacle-1',obstacleSize: 1 },
    { obstacleId: 'obstacle-2',obstacleSize: 1 },
    { obstacleId: 'obstacle-3',obstacleSize: 1 }
  ]
};